<div *ngIf="summaryData" class="w-full h-full grid grid-cols-4 relative rounded-xl overflow-hidden">

  <!-- Step Start -->
  <div class="relative flex flex-col items-center justify-between text-center h-full py-3 px-4 bg-white rounded-l-xl">
    <div class="flex flex-col items-center gap-[1px] w-full">
      <span class="text-[0.55rem] xl:text-[0.6rem] 2xl:text-[0.7rem] font-[MontserratBold] uppercase tracking-[0.12em] text-dimot-1 mb-1">Step</span>
      <h1 class="text-[0.75rem] xl:text-[0.875rem] 2xl:text-[1rem] font-[MontserratBold] text-dimot-1">Start</h1>
      <div class="min-h-[42px] flex items-start justify-center w-full">
        <p class="text-[0.5rem] xl:text-[0.55rem] 2xl:text-[0.625rem] text-gray-500 leading-relaxed font-medium w-full">
          Gazzetta Ufficiale della Repubblica Italiana
        </p>
      </div>
    </div>

    <div class="flex-1 flex items-center justify-center">
      <h2 class="text-[1.6rem] xl:text-[1.85rem] 2xl:text-[2rem] font-[MontserratBold] text-dimot-1 leading-none">
        {{ summaryData.metrics.stepZeroCount }}
      </h2>
    </div>

    <div class="w-full flex justify-center mt-3">
      <button
        (click)="openModal('start')"
        class="px-4 py-1.5 rounded-md text-[0.55rem] xl:text-[0.65rem] 2xl:text-[0.7rem] font-medium border border-gray-200 bg-white text-dimot-1 hover:bg-gray-50 hover:border-gray-300 transition-all duration-200 cursor-pointer"
      >
        Dettagli
      </button>
    </div>

    <!-- Connector arrow to next step -->
    <div class="hidden md:flex absolute -right-2.5 top-1/2 -translate-y-1/2 z-10 items-center justify-center w-5 h-5 rounded-full bg-white border border-gray-200 text-gray-300">
      <svg width="9" height="9" viewBox="0 0 9 9" fill="none"><path d="M2.5 1.5L7.5 4.5L2.5 7.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
    </div>
  </div>

  <!-- Step Inclusione Regionale -->
  <div class="relative flex flex-col items-center justify-between text-center h-full py-3 px-4 bg-dimot-1/[0.03]">
    <div class="flex flex-col items-center gap-[1px] w-full">
      <span class="text-[0.55rem] xl:text-[0.6rem] 2xl:text-[0.7rem] font-[MontserratBold] uppercase tracking-[0.12em] text-dimot-1 mb-1">Step</span>
      <h1 class="text-[0.75rem] xl:text-[0.875rem] 2xl:text-[1rem] font-[MontserratBold] text-dimot-1">Inclusione Regionale</h1>
      <div class="min-h-[42px] flex items-start justify-center w-full">
        <p class="text-[0.5rem] xl:text-[0.55rem] 2xl:text-[0.625rem] text-gray-500 leading-relaxed font-medium w-full">
          Delibera Centri Prescrittori Regionale o<br>
          Inserimento in Prontuario Terapeutico Regionale o<br>
          Delibera di Recepimento Regionale
        </p>
      </div>
    </div>

    <div class="flex-1 flex items-center justify-center">
      <h2 class="text-[1.6rem] xl:text-[1.85rem] 2xl:text-[2rem] font-[MontserratBold] text-dimot-1 leading-none">
        {{ summaryData.metrics.openToAccessCount }}
      </h2>
    </div>

    <div class="w-full flex justify-center mt-3">
      <button
        (click)="openModal('openToAccess')"
        class="px-4 py-1.5 rounded-md text-[0.55rem] xl:text-[0.65rem] 2xl:text-[0.7rem] font-medium border border-gray-200 bg-white text-dimot-1 hover:bg-gray-50 hover:border-gray-300 transition-all duration-200 cursor-pointer"
      >
        Dettagli
      </button>
    </div>

    <div class="hidden md:flex absolute -right-2.5 top-1/2 -translate-y-1/2 z-10 items-center justify-center w-5 h-5 rounded-full bg-white border border-gray-200 text-gray-300">
      <svg width="9" height="9" viewBox="0 0 9 9" fill="none"><path d="M2.5 1.5L7.5 4.5L2.5 7.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
    </div>
  </div>

  <!-- Step Aggiudicazione Gara -->
  <div class="relative flex flex-col items-center justify-between text-center h-full py-3 px-4 bg-dimot-1/[0.07]">
    <div class="flex flex-col items-center gap-[1px] w-full">
      <span class="text-[0.55rem] xl:text-[0.6rem] 2xl:text-[0.7rem] font-[MontserratBold] uppercase tracking-[0.12em] text-dimot-1 mb-1">Step</span>
      <h1 class="text-[0.75rem] xl:text-[0.875rem] 2xl:text-[1rem] font-[MontserratBold] text-dimot-1">Aggiudicazione Gara</h1>
      <div class="min-h-[42px] flex items-start justify-center w-full">
        <p class="text-[0.5rem] xl:text-[0.55rem] 2xl:text-[0.625rem] text-gray-500 leading-relaxed font-medium w-full">
          Conclusione della procedura di gara <br> ed assegnazione del CIG
        </p>
      </div>
    </div>

    <div class="flex-1 flex items-center justify-center">
      <h2 class="text-[1.6rem] xl:text-[1.85rem] 2xl:text-[2rem] font-[MontserratBold] text-dimot-1 leading-none">
        {{ summaryData.metrics.aggiudicazioneGaraCount }}
      </h2>
    </div>

    <div class="w-full flex justify-center mt-3">
      <button
        (click)="openModal('aggiudicazioneGara')"
        class="px-4 py-1.5 rounded-md text-[0.55rem] xl:text-[0.65rem] 2xl:text-[0.7rem] font-medium border border-gray-200 bg-white text-dimot-1 hover:bg-gray-50 hover:border-gray-300 transition-all duration-200 cursor-pointer"
      >
        Dettagli
      </button>
    </div>

    <div class="hidden md:flex absolute -right-2.5 top-1/2 -translate-y-1/2 z-10 items-center justify-center w-5 h-5 rounded-full bg-white border border-gray-200 text-gray-300">
      <svg width="9" height="9" viewBox="0 0 9 9" fill="none"><path d="M2.5 1.5L7.5 4.5L2.5 7.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
    </div>
  </div>

  <!-- Step Possibilità di Acquisto -->
  <div class="relative flex flex-col items-center justify-between text-center h-full py-3 px-4 bg-dimot-1/[0.12] rounded-r-xl">
    <div class="flex flex-col items-center gap-[1px] w-full">
      <span class="text-[0.55rem] xl:text-[0.6rem] 2xl:text-[0.7rem] font-[MontserratBold] uppercase tracking-[0.12em] text-dimot-1 mb-1">Step</span>
      <h1 class="text-[0.75rem] xl:text-[0.875rem] 2xl:text-[1rem] font-[MontserratBold] text-dimot-1">Possibilità di Acquisto</h1>
      <div class="min-h-[42px] flex items-start justify-center w-full">
        <p class="text-[0.5rem] xl:text-[0.55rem] 2xl:text-[0.625rem] text-gray-500 leading-relaxed font-medium w-full">
          da parte della struttura, a seguito del recepimento dei termini della gara centralizzata e dell'inserimento del CIG
        </p>
      </div>
    </div>

    <div class="flex-1 flex items-center justify-center">
      <h2 class="text-[1.6rem] xl:text-[1.85rem] 2xl:text-[2rem] font-[MontserratBold] text-dimot-1 leading-none">
        {{ summaryData.metrics.openToMarketHospitalCount }}
      </h2>
    </div>

    <div class="w-full flex justify-center mt-3">
      <button
        (click)="openModal('openToMarket')"
        class="px-4 py-1.5 rounded-md text-[0.55rem] xl:text-[0.65rem] 2xl:text-[0.7rem] font-medium border border-gray-200 bg-white text-dimot-1 hover:bg-gray-50 hover:border-gray-300 transition-all duration-200 cursor-pointer"
      >
        Dettagli
      </button>
    </div>
  </div>

</div>

<!-- Modal -->
<app-modal-inclusion-process-tool-national
  *ngIf="isModalOpen"
  [segment]="activeSegment"
  [data]="summaryData!"
  (closeModal)="closeModal()"
>
</app-modal-inclusion-process-tool-national>